import { render, staticRenderFns } from "./ValidationAlertByValidator.vue?vue&type=template&id=c6ba5a8c&scoped=true&lang=pug"
import script from "./ValidationAlertByValidator.vue?vue&type=script&lang=ts"
export * from "./ValidationAlertByValidator.vue?vue&type=script&lang=ts"
import style0 from "./ValidationAlertByValidator.vue?vue&type=style&index=0&id=c6ba5a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ba5a8c",
  null
  
)

export default component.exports